const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/console/_auth/_layout/system/department.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { type DepartmentItem, type HisDeptCandidate, type WeworkDepartmentItem } from '@/api/department';
export const Route = createFileRoute('/console/_auth/_layout/system/department')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
interface DepartmentTreeNode extends DepartmentItem {
  children?: DepartmentTreeNode[];
}

// 扁平列表转树形结构

interface HisDeptTreeNode extends HisDeptCandidate {
  children: HisDeptTreeNode[];
  // 同一代码对应多个科室时标注: 映射按代码生效, 勾选任一个等同勾选全部同代码科室
  sharedCode: boolean;
  // 已映射但不在当前字典里的科室(字典重新同步或科室作废), 只读展示不再参与过滤
  missingFromDict: boolean;
}

// HIS 科室扁平候选转树: parentId 指向上级的 dept_index_no, 为空或指向不存在的节点即为根
// extraMapped 是已映射但字典里已无对应科室的条目, 挂成根节点保证不会被静默丢掉

// 按关键字与临床标志过滤树
// 命中的判定沿两个方向传导, 缺一都会让树用不了: 子命中要保留父级(否则子科室无处展示),
// 父命中要带出整棵子树(否则搜到一个组却看不到也勾不了它的子科室)
// 已勾选与字典中已消失的条目一律保留, 否则会在保存时被静默丢掉

// 收集节点自身与全部后代, 供父节点整组勾选

// 企微部门扁平列表转树: parentId 为空或指向不存在的节点即为根
// 过滤规则与 HIS 映射一致: 命中沿父子两个方向传导, 已勾选的一律保留

interface WeworkDeptTreeNode extends WeworkDepartmentItem {
  children: WeworkDeptTreeNode[];
}

// 企微部门树形多选: 结构与 HIS 映射一致
// 一个企微部门只能归入一个业务科室, 勾选已被别的科室占用的部门会把它转移过来, 故在行内标出当前归属

// HIS 科室树形多选: 每个节点是一个可映射科室(父节点自身也有科室代码), 勾选按代码生效
// 父节点另给「全选/取消本组」按钮, 勾选父节点本身不联动子级——父科室有自己的就诊记录, 两者是不同的映射
// ---- 主页面 ----
// ---- 左列：Profile 卡片（可编辑，保存到数据库） ----
// ---- 右列：能力配置（只读展示） ----
// ---- 右列：知识库关联（纯展示） ----
// ---- 右列：安全规则（纯展示） ----
// ---- 公共小组件 ----
// endregion
// niceDomain 把上下界对齐到 1/2/5 系列的整齐步长，避免出现 38.7 这种刻度
// endregion
// endregion
// SwipeRow 仅对可删除行启用左滑露出删除按钮,其他行直接透传内容
// endregion
// AI 巡查风险等级 → 徽章文案与色调
// 随访状态 → 徽章文案与色调, 已取消的不会出现在首页
// 复查提醒与随访卡片的统计范围说明
// 用户来源分类与条形配色, 顺序即展示顺序; 平台是「无院内记录」的兜底类, 用中性灰
// 各指标的口径说明, 集中放一处便于核对
// endregion
// 管理视角: 超管额外看到管理归属、覆盖、活跃趋势与功能使用; 健管师 / 运营员只看基础概览
// 超管的核心指标: 用真实的活跃与新增替代原先写死的两项 100%
// region 复查提醒与患者随访
// 管理视角和医生工作台共用, 统计范围由服务端按角色决定, 卡片描述里写明
// 上面一排底色统计格, 下面是近 7 天的明细列表
// endregion
// 用户来源分布: 横向条形, 全为 0(含数据未就绪)时按无数据占位
// 指标行:仿模板 KPI 行;纯数字走 KPI.Value,带 % 等符号的直接文本渲染
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}